<div class="overview-wrapper">
  <div class="table-scroll-container">
    <table
      mat-table
      [dataSource]="dataSource"
      id="packaging-units-table"
      matSort
      [matSortActive]="getActiveSortColumn()"
      [matSortDirection]="getActiveSortDirection()"
      (matSortChange)="onSortChanged($event)">
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div (click)="$event.stopPropagation()">
            <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.filterMenu" [matMenuTriggerData]="{ caller: getCaller('id') }" type="button">
              {{ 'commonPackagingFields.id' | transloco }}
              <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('id'))">filter_alt</mat-icon>
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">{{ element.id }}</td>
      </ng-container>

      <ng-container matColumnDef="analysisId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'commonPackagingFields.id' | transloco }}
        </th>
        <td mat-cell *matCellDef="let element">{{ getAnalysisIdForPackaging(element.id) }}</td>
      </ng-container>

      <ng-container matColumnDef="tracking">
        <th mat-header-cell *matHeaderCellDef [hidden]="!displayTrackedColumn"></th>
        <td mat-cell *matCellDef="let element" [hidden]="!displayTrackedColumn">
          <mat-icon *ngIf="element.hasExternalTracking">track_changes</mat-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="tags">
        <th mat-header-cell *matHeaderCellDef>
          <div (click)="$event.stopPropagation()">
            <button
              mat-button
              class="filter-button"
              [matMenuTriggerFor]="filterComponent.tagFilterMenu"
              [matMenuTriggerData]="{ caller: getCaller('tags'), possibleTags: getPossibleTags() }"
              type="button">
              {{ 'dataManagement.tags.titleTags' | transloco }}
              <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('tags'))">filter_alt </mat-icon>
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          <app-tag-directive [tags]="getTagsFromIds(element.associatedTagIdentifiers)" [maxDisplayed]="2"> </app-tag-directive>
        </td>
      </ng-container>

      <ng-container matColumnDef="packagingTypeName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div (click)="$event.stopPropagation()">
            <button
              mat-button
              class="filter-button"
              [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
              [matMenuTriggerData]="{ caller: getCaller('packagingTypeName'), categories: getPackagingUnitTypes() }"
              type="button">
              {{ 'packagingUnit.packagingUnitType' | transloco }}
              <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('packagingTypeName'))">filter_alt</mat-icon>
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          <img [src]="getPackagingUnitTypeImage(element.packagingTypeId)" class="packaging-type-image" [matTooltip]="element.packagingTypeName" />
        </td>
      </ng-container>

      <ng-container matColumnDef="brandName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div (click)="$event.stopPropagation()">
            <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.filterMenu" [matMenuTriggerData]="{ caller: getCaller('brandName') }" type="button">
              {{ 'packagingUnit.fields.brandName' | transloco }}
              <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('brandName'))">filter_alt</mat-icon>
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">{{ element.brandName }}</td>
      </ng-container>

      <ng-container matColumnDef="productName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div (click)="$event.stopPropagation()">
            <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.filterMenu" [matMenuTriggerData]="{ caller: getCaller('productName') }" type="button">
              {{ 'packagingUnit.fields.productName' | transloco }}
              <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('productName'))">filter_alt</mat-icon>
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">{{ element.productName }}</td>
      </ng-container>

      <ng-container matColumnDef="supplier">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div (click)="$event.stopPropagation()">
            <button
              mat-button
              class="filter-button"
              [matMenuTriggerFor]="filterComponent.multiSelectFilterMenu"
              [matMenuTriggerData]="{ caller: getCaller('supplier'), translation: 'supplier', categories: suppliers }"
              type="button">
              {{ 'packagingUnit.fields.supplier' | transloco }}
              <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('supplier'))">filter_alt</mat-icon>
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">{{ element.supplier }}</td>
      </ng-container>

      <ng-container matColumnDef="articleNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div (click)="$event.stopPropagation()">
            <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.filterMenu" [matMenuTriggerData]="{ caller: getCaller('articleNumber') }" type="button">
              {{ 'packagingUnit.fields.articleNumber' | transloco }}
              <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('articleNumber'))">filter_alt</mat-icon>
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">{{ element.articleNumber }}</td>
      </ng-container>

      <ng-container matColumnDef="creationTimestamp">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'commonPackagingFields.creationDate' | transloco }}</th>
        <td mat-cell *matCellDef="let element">
          {{ formatDateToString(element.creationTimestamp) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="lastModificationTimestamp">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'commonPackagingFields.lastModificationDate' | transloco }}</th>
        <td mat-cell *matCellDef="let element">
          {{ formatDateToString(element.lastModificationTimestamp) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="quantityInput">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div (click)="$event.stopPropagation()">
            <button mat-button class="filter-button" type="button">
              {{ 'dataManagement.quantities.quantity' | transloco }}
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let element; let index = index">
          <mat-form-field id="quantity-form">
            <input matInput type="number" autocomplete="off" [formControl]="getFormControlForQuantity(element)" appStopNumberScrolling />
            <button
              mat-icon-button
              matSuffix
              *ngIf="getFormControlForQuantity(element).disabled"
              (click)="addCountryToPackaging(element)"
              id="add-country-button"
              matTooltip="{{ 'dataManagement.quantities.addDistrCountryTooltip' | transloco }}">
              <mat-icon id="add-country-icon">add_location_alt</mat-icon>
            </button>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>
          <span class="header-text">{{ 'dataManagement.actions' | transloco }}</span>
        </th>
        <td mat-cell *matCellDef="let element">
          <button
            *ngIf="!isRecyclingBinSelected && !isUserValidator; else viewPackaging"
            mat-icon-button
            (click)="navigateToPackagingUnit(element)"
            matTooltip="{{ 'packagingUnit.editPackagingUnit' | transloco }}"
            type="button">
            <mat-icon>edit</mat-icon>
          </button>
          <ng-template #viewPackaging>
            <button
              *ngIf="!isRecyclingBinSelected"
              mat-icon-button
              (click)="navigateToPackagingUnit(element)"
              matTooltip="{{ 'packagingUnit.viewPackagingUnit' | transloco }}"
              type="button">
              <mat-icon>preview</mat-icon>
            </button>
          </ng-template>
          <button
            mat-icon-button
            *ngIf="!isUserValidator"
            (click)="deletePackagingPart([element.id])"
            matTooltip="{{ 'packagingUnit.deletePackagingUnit' | transloco }}"
            type="button">
            <mat-icon>delete_forever</mat-icon>
          </button>
          <span class="full-button-height" *ngIf="!isRecyclingBinSelected">
            <button
              mat-icon-button
              [matMenuTriggerFor]="analyses.analysesMenu"
              type="button"
              *ngIf="!isGenericPackaging(element.packagingTypeId); else disabledAnalysisButton"
              (click)="analyses.loadAnalysesForPackagingUnit()"
              matTooltip="{{ 'home.packagingUnitHome.evaluations' | transloco }}">
              <mat-icon class="green-icon">eco</mat-icon>
            </button>
            <ng-template #disabledAnalysisButton>
              <span class="full-button-height" matTooltip="{{ 'home.packagingUnitHome.evaluationsDisabled' | transloco }}">
                <button mat-icon-button disabled>
                  <mat-icon>eco</mat-icon>
                </button>
              </span>
            </ng-template>
          </span>
          <button
            mat-icon-button
            [matMenuTriggerFor]="reports.reportsMenu"
            (click)="reports.loadReports()"
            matTooltip="{{ 'report.tooltips.buttonTooltip' | transloco }}"
            *ngIf="!isRecyclingBinSelected && !isUserValidator"
            type="button">
            <mat-icon>topic</mat-icon>
          </button>

          <app-analyses-menu-packaging-units
            #analyses
            [packagingUnitId]="element.id"
            [packagingUnitType]="element.packagingTypeId"
            [versionId]="element.version"
            [isUserValidator]="isUserValidator"
            [caller]="callerPageId"
            (validationData)="setValidationData($event)"
            [hasRecyclabilityResult]="element.hasRecyclabilityResult"
            [hasLifeCycleResult]="element.hasLifeCycleResult"
            [creationTimestamp]="element.creationTimestamp"
            [analysisWrappersRec]="getAnalysisWrappersRecForPackaging(element.id)"
            [analysisWrappersLca]="getAnalysisWrappersLcaForPackaging(element.id)">
          </app-analyses-menu-packaging-units>
          <app-reports-menu-for-packaging-part #reports [callerItemId]="element.id" [callerPage]="callerPageId" [callerLevel]="callerLevelId">
          </app-reports-menu-for-packaging-part>
        </td>
      </ng-container>

      <ng-container matColumnDef="compare">
        <th mat-header-cell *matHeaderCellDef>
          <span class="header-text">{{ 'packagingUnit.fields.compare' | transloco }}</span>
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-checkbox [checked]="isPackagingUnitSelected(element)" (change)="setPackagingUnitSelected($event.checked, element)"></mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="select" stickyEnd>
        <th mat-header-cell *matHeaderCellDef>
          <div (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" role="button" tabindex="0">
            <button mat-button class="filter-button" (click)="selectAllPackagingUnits()" type="button">
              {{ 'common.buttons.selectAll' | transloco }} <br />
              ({{ selectedPackagingUnitIds.length }})
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-checkbox [checked]="isPackagingUnitSelected(element)" (change)="setPackagingUnitSelected($event.checked, element)"> </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="validation">
        <th mat-header-cell *matHeaderCellDef>
          <span class="header-text">{{ 'packagingUnit.validationStatus' | transloco }}</span>
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-icon *ngIf="isFullyValidatedAllValid(element.id)" class="validation-green">check</mat-icon>
          <mat-icon *ngIf="isFullyValidatedNotAllValid(element.id)" class="validation-red">clear</mat-icon>
          <mat-icon *ngIf="isNotFullyValidated(element.id) && isTouched(element.id)" class="validation-blue">auto_fix_high </mat-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="organizationId">
        <th mat-header-cell *matHeaderCellDef>
          <span class="header-text">{{ 'packagingUnit.organization' | transloco }}</span>
        </th>
        <td mat-cell *matCellDef="let element">{{ getOrganizationName(element.organizationId) }}</td>
      </ng-container>

      <ng-container matColumnDef="directoryName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div (click)="$event.stopPropagation()">
            <button
              mat-button
              class="filter-button"
              [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
              [matMenuTriggerData]="{ caller: getCaller('directoryName'), categories: directories }"
              type="button">
              {{ 'packagingUnit.fields.directoryName' | transloco }}
              <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('directoryName'))">filter_alt</mat-icon>
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">{{ element.directoryName }}</td>
      </ng-container>

      <ng-container matColumnDef="infoButton">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button (click)="infoButtonClick.emit(element)" type="button" color="primary">
            <mat-icon>info</mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="subRequestStatus">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <button
            mat-button
            class="filter-button"
            type="button"
            (click)="$event.stopPropagation()"
            [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
            [matMenuTriggerData]="{ caller: getCaller('subRequestStatus'), categories: getStatusOptions() }">
            {{ 'dataManagement.dataExchangeRequests.columns.status' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('subRequestStatus'))">filter_alt</mat-icon>
          </button>
        </th>
        <td mat-cell *matCellDef="let element">{{ getSubRequestStatusLabel(subRequestMap?.get(element.id)?.status) | transloco }}</td>
      </ng-container>

      <ng-container matColumnDef="showSubRequestComments">
        <th mat-header-cell *matHeaderCellDef style="width: 48px"></th>
        <td mat-cell *matCellDef="let element" style="width: 48px">
          <button mat-icon-button type="button" (click)="showSubRequestComments.emit(element.id); $event.stopPropagation()">
            <mat-icon [matBadge]="commentCountMap?.get(element.id)" [matBadgeHidden]="!commentCountMap?.get(element.id)" matBadgeColor="primary" matBadgeSize="small"
              >comment</mat-icon
            >
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="navigateToSubRequest">
        <th mat-header-cell *matHeaderCellDef style="width: 48px"></th>
        <td mat-cell *matCellDef="let element" style="width: 48px">
          <button
            [disabled]="subRequestMap?.get(element.id)?.status === DataExchangeRequestStatusDto.Deleted"
            mat-icon-button
            type="button"
            [title]="'dataManagement.dataExchangeRequests.actions.openSubRequest' | transloco"
            (click)="navigateToSubRequest.emit(element.id); $event.stopPropagation()">
            <mat-icon>open_in_new</mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="lastModifiedAt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <button
            mat-button
            class="filter-button"
            type="button"
            (click)="$event.stopPropagation()"
            [matMenuTriggerFor]="filterComponent.dateFilterMenu"
            [matMenuTriggerData]="{ caller: 'lastModifiedAt' }">
            {{ 'dataManagement.dataExchangeRequests.columns.lastModifiedAt' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes('lastModifiedAt')">filter_alt</mat-icon>
          </button>
        </th>
        <td mat-cell *matCellDef="let row">{{ getDate(subRequestMap?.get(row.id)?.lastModifiedAt) | date: 'short' }}</td>
      </ng-container>

      <ng-container matColumnDef="approveSubRequest">
        <th mat-header-cell *matHeaderCellDef style="width: 100px; text-align: center">{{ 'dataManagement.actions' | transloco }}</th>
        <td mat-cell *matCellDef="let element" style="width: 148px">
          <button
            mat-icon-button
            type="button"
            [disabled]="subRequestMap?.get(element.id)?.status !== DataExchangeRequestStatusDto.Submitted"
            [title]="'dataManagement.dataExchangeRequests.actions.approveSubRequest' | transloco"
            (click)="approveSubRequest.emit(element.id); $event.stopPropagation()">
            <mat-icon>check_circle</mat-icon>
          </button>
          <button
            mat-icon-button
            type="button"
            [disabled]="subRequestMap?.get(element.id)?.status !== DataExchangeRequestStatusDto.Submitted"
            [title]="'dataManagement.dataExchangeRequests.actions.reopenSubRequest' | transloco"
            (click)="reopenSubRequest.emit(element.id); $event.stopPropagation()">
            <mat-icon>replay</mat-icon>
          </button>
          <button
            mat-icon-button
            type="button"
            [disabled]="subRequestMap?.get(element.id)?.status === DataExchangeRequestStatusDto.Deleted"
            [title]="'dataManagement.dataExchangeRequests.actions.withdrawSubRequest' | transloco"
            (click)="withdrawSubRequest.emit(element.id); $event.stopPropagation()">
            <mat-icon>undo</mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="gtin">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div (click)="$event.stopPropagation()">
            <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.filterMenu" [matMenuTriggerData]="{ caller: getCaller('gtin') }" type="button">
              {{ 'packagingUnit.fields.gtin' | transloco }}
              <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('gtin'))">filter_alt</mat-icon>
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">{{ element.gtin }}</td>
      </ng-container>

      <ng-container matColumnDef="fillingGoodTypeId">
        <th mat-header-cell *matHeaderCellDef>
          <div (click)="$event.stopPropagation()">
            <button
              mat-button
              class="filter-button"
              [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
              [matMenuTriggerData]="{ caller: getCaller('fillingGoodTypeId'), categories: getFillingGoodTypeOptions() }"
              type="button">
              {{ 'packagingUnit.fields.fillingGoodProductRange' | transloco }}
              <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('fillingGoodTypeId'))">filter_alt</mat-icon>
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">{{ element.fillingGoodTypeName }}</td>
      </ng-container>

      <ng-container matColumnDef="fillingGoodCategoryId">
        <th mat-header-cell *matHeaderCellDef>
          <div (click)="$event.stopPropagation()">
            <button
              mat-button
              class="filter-button"
              [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
              [matMenuTriggerData]="{ caller: getCaller('fillingGoodCategoryId'), categories: getFillingGoodCategoryOptions() }"
              type="button">
              {{ 'packagingUnit.fields.fillingGoodCategory' | transloco }}
              <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('fillingGoodCategoryId'))">filter_alt</mat-icon>
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">{{ element.fillingGoodCategoryName }}</td>
      </ng-container>

      <ng-container matColumnDef="fillingGoodId">
        <th mat-header-cell *matHeaderCellDef>
          <div (click)="$event.stopPropagation()">
            <button
              mat-button
              class="filter-button"
              [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
              [matMenuTriggerData]="{ caller: getCaller('fillingGoodId'), categories: getFillingGoodOptions() }"
              type="button">
              {{ 'packagingUnit.fields.fillingGoodProductCategory' | transloco }}
              <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('fillingGoodId'))">filter_alt</mat-icon>
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">{{ element.fillingGoodName }}</td>
      </ng-container>

      <ng-container matColumnDef="packagingQuantity">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'packagingUnit.fields.fillingQuantity' | transloco }}</th>
        <td mat-cell *matCellDef="let element">{{ element.packagingQuantity }}</td>
      </ng-container>

      <ng-container matColumnDef="packagingVolume">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'packagingUnit.fields.fillingVolume' | transloco }}</th>
        <td mat-cell *matCellDef="let element">{{ element.packagingVolume }}</td>
      </ng-container>

      <ng-container matColumnDef="distributionCountries">
        <th mat-header-cell *matHeaderCellDef>
          <div (click)="$event.stopPropagation()">
            <button
              mat-button
              class="filter-button"
              [matMenuTriggerFor]="filterComponent.tagFilterMenu"
              [matMenuTriggerData]="{ caller: getCaller('distributionCountries'), possibleTags: getDistributionCountryOptions() }"
              type="button">
              {{ 'packagingUnit.fields.countriesOfDistribution' | transloco }}
              <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('distributionCountries'))">filter_alt</mat-icon>
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">{{ element.distributionCountries?.join(', ') }}</td>
      </ng-container>

      <ng-container matColumnDef="assemblyCountry">
        <th mat-header-cell *matHeaderCellDef>
          <div (click)="$event.stopPropagation()">
            <button
              mat-button
              class="filter-button"
              [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
              [matMenuTriggerData]="{ caller: getCaller('assemblyCountry'), categories: getManufacturingCountryOptions() }"
              type="button">
              {{ 'packagingUnit.fields.assemblyCountry' | transloco }}
              <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('assemblyCountry'))">filter_alt</mat-icon>
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">{{ element.assemblyCountry }}</td>
      </ng-container>

      <ng-container matColumnDef="length">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'component.fields.length' | transloco }}</th>
        <td mat-cell *matCellDef="let element">{{ element.length }}</td>
      </ng-container>

      <ng-container matColumnDef="width">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'component.fields.width' | transloco }}</th>
        <td mat-cell *matCellDef="let element">{{ element.width }}</td>
      </ng-container>

      <ng-container matColumnDef="height">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'component.fields.height' | transloco }}</th>
        <td mat-cell *matCellDef="let element">{{ element.height }}</td>
      </ng-container>

      <ng-container matColumnDef="hasImagess">
        <th mat-header-cell *matHeaderCellDef>
          <div (click)="$event.stopPropagation()">
            <button
              mat-button
              class="filter-button"
              [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
              [matMenuTriggerData]="{ caller: getCaller('hasImagess'), categories: getYesNoOptions() }"
              type="button">
              {{ 'image.productImages' | transloco }}
              <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('hasImagess'))">filter_alt</mat-icon>
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">{{ (element.hasImagess ? 'common.dictionary.yes' : 'common.dictionary.no') | transloco }}</td>
      </ng-container>

      <ng-container matColumnDef="hasCertificates">
        <th mat-header-cell *matHeaderCellDef>
          <div (click)="$event.stopPropagation()">
            <button
              mat-button
              class="filter-button"
              [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
              [matMenuTriggerData]="{ caller: getCaller('hasCertificates'), categories: getYesNoOptions() }"
              type="button">
              {{ 'certificate.certificates' | transloco }}
              <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('hasCertificates'))">filter_alt</mat-icon>
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">{{ (element.hasCertificates ? 'common.dictionary.yes' : 'common.dictionary.no') | transloco }}</td>
      </ng-container>

      <ng-container matColumnDef="hasAdditionalDocuments">
        <th mat-header-cell *matHeaderCellDef>
          <div (click)="$event.stopPropagation()">
            <button
              mat-button
              class="filter-button"
              [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
              [matMenuTriggerData]="{ caller: getCaller('hasAdditionalDocuments'), categories: getYesNoOptions() }"
              type="button">
              {{ 'pdf.productPdfs' | transloco }}
              <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('hasAdditionalDocuments'))">filter_alt</mat-icon>
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">{{ (element.hasAdditionalDocuments ? 'common.dictionary.yes' : 'common.dictionary.no') | transloco }}</td>
      </ng-container>

      <ng-container matColumnDef="hasPPWRDocuments">
        <th mat-header-cell *matHeaderCellDef>
          <div (click)="$event.stopPropagation()">
            <button
              mat-button
              class="filter-button"
              [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
              [matMenuTriggerData]="{ caller: getCaller('hasPPWRDocuments'), categories: getYesNoOptions() }"
              type="button">
              {{ 'home.filter.technicalDocumentationDataShort' | transloco }}
              <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('hasPPWRDocuments'))">filter_alt</mat-icon>
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">{{ (element.hasPPWRDocuments ? 'common.dictionary.yes' : 'common.dictionary.no') | transloco }}</td>
      </ng-container>

      <ng-container matColumnDef="packagingLevel">
        <th mat-header-cell *matHeaderCellDef>
          <div (click)="$event.stopPropagation()">
            <button
              mat-button
              class="filter-button"
              [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
              [matMenuTriggerData]="{ caller: getCaller('packagingLevel'), categories: getPackagingLevelOptions() }"
              type="button">
              {{ 'packagingUnit.fields.packagingLevelHeader' | transloco }}
              <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('packagingLevel'))">filter_alt</mat-icon>
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">{{ getPackagingLevelLabel(element.packagingLevel) }}</td>
      </ng-container>

      <ng-container matColumnDef="isPackagingPartOfProduct">
        <th mat-header-cell *matHeaderCellDef>
          <div (click)="$event.stopPropagation()">
            <button
              mat-button
              class="filter-button"
              [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
              [matMenuTriggerData]="{ caller: getCaller('isPackagingPartOfProduct'), categories: getYesNoOptions() }"
              type="button">
              {{ 'home.filter.isPackagingPartOfProductShort' | transloco }}
              <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('isPackagingPartOfProduct'))">filter_alt</mat-icon>
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          {{
            (element.isPackagingPartOfProduct == null ? 'common.dictionary.notSpecified' : element.isPackagingPartOfProduct ? 'common.dictionary.yes' : 'common.dictionary.no')
              | transloco
          }}
        </td>
      </ng-container>

      <ng-container matColumnDef="isMultiUsePackaging">
        <th mat-header-cell *matHeaderCellDef>
          <div (click)="$event.stopPropagation()">
            <button
              mat-button
              class="filter-button"
              [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
              [matMenuTriggerData]="{ caller: getCaller('isMultiUsePackaging'), categories: getYesNoOptions() }"
              type="button">
              {{ 'home.filter.isMultiUsePackagingShort' | transloco }}
              <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('isMultiUsePackaging'))">filter_alt</mat-icon>
            </button>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          {{
            (element.isMultiUsePackaging == null ? 'common.dictionary.notSpecified' : element.isMultiUsePackaging ? 'common.dictionary.yes' : 'common.dictionary.no') | transloco
          }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        [ngClass]="isPackagingUnitSelected(row) ? 'background-highlight' : ''"
      ></tr>

      <app-filter-menu #filterComponent="columnFilterComponent" [dataSource]="dataSource"></app-filter-menu>
    </table>

    <div class="loading-overlay" *ngIf="isLoading | async">
      <mat-spinner diameter="48" color="accent"></mat-spinner>
    </div>
  </div>

  <div class="pagination-row" *ngIf="isPaginatorVisible">
    <button *ngIf="showColumnOrganizer" mat-stroked-button class="column-organizer-button" (click)="openColumnSettingsDialog()" type="button">
      <mat-icon>view_column</mat-icon>
      {{ 'common.buttons.organizeColumns' | transloco }}
    </button>
    <mat-paginator [length]="1" [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page" (page)="onPageChanged($event)"> </mat-paginator>
  </div>
</div>
